import {ExpressionNode} from './expression-node';
import {SerializedOperand} from './types';

export class OperandNode extends ExpressionNode {
  constructor(
    public operand: SerializedOperand,
    public left: ExpressionNode = null,
    public right: ExpressionNode = null,
  ) {
    super(left, right);
    if (operand.data_group_id === undefined) {
      delete operand.data_group_id;
    }
    if (operand.temp_data_group_id === undefined) {
      delete operand.temp_data_group_id;
    }
    if (operand.join_property_type === undefined) {
      delete operand.join_property_type;
    }
  }

  public serialize(): SerializedOperand {
    return this.operand;
  }
}
